// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills_ycF9O","listItem":"Skills_listItem_c3HPG"};